/**
 * Core
 */
import { getGender, isValidGender, simplyClick } from "../../helpers";
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import StepWrapper from "../StepWrapper";
import SelectGlobal from "../SelectGlobal";
import ButtonGlobal from "../ButtonGlobal";

const Gender = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorGender, setErrorGender] = useState(null);
  const handleChangeGender = (event) => {
    setErrorGender(null);
    setData({ ...data, gender: event.target?.value.toString() });
  };

  const handleNextStep = () => {
    if (!isValidGender(data?.gender)) {
      setErrorGender("Please, choose your gender ");
    } else {
      simplyClick("cl_lnd_am31_i_am_cont", { gender: data?.gender });
      setStep(step + 1);
    }
  };

  return (
    <StepWrapper step={step} stepLabel={"I am a:"}>
      <SelectGlobal
        error={!!errorGender}
        data={data?.gender}
        dateArray={getGender()}
        label={"Gender"}
        handleChange={(e) => handleChangeGender(e)}
      />
      {errorGender && <p className="error-text">{errorGender}</p>}
      <div className="button_wrap">
        <ButtonGlobal text={"Continue"} cb={handleNextStep} />
      </div>
    </StepWrapper>
  );
};
export default Gender;
